const iconsData = {
  'React.js': 'http://formatjs.io/img/react.svg',
  'Node.js': 'https://cdn2.iconfinder.com/data/icons/nodejs-1/512/nodejs-512.png',
  express: 'https://cdn2.iconfinder.com/data/icons/nodejs-1/512/nodejs-512.png',
  PostgreSQL: 'http://tapoueh.org/images/220px-Postgresql_elephant.svg.png',
  'socket.io': 'https://www.pubnub.com/blog/wp-content/uploads/2014/07/SOCKETIOICON.gif',
  Ionic: 'http://uxrepo.com/static/icon-sets/ionicons/svg/ionic.svg',
  AngularJS: 'https://lh6.googleusercontent.com/-TlY7amsfzPs/T9ZgLXXK1cI/AAAAAAABK-c/Ki-inmeYNKk/w800-h800/AngularJS-Shield-large.png',
  MongoDB: 'http://www.todobackend.com/images/logos/mongodb.png',
  neo4j: 'https://avatars3.githubusercontent.com/u/218965?v=3&s=200',
  'd3.js': 'https://upload.wikimedia.org/wikipedia/en/thumb/1/15/Logo_D3.svg/1079px-Logo_D3.svg.png',
  Leaflet: 'http://leafletjs.com/docs/images/logo.png',
  Redux: 'https://rawgit.com/gorangajic/react-icons/master/react-icons.svg'
};

export { iconsData };



/** WEBPACK FOOTER **
 ** ./src/data/techStackIcons.js
 **/